import { SvgIcon, SvgIconProps } from '@mui/material';

const HexagonCompleteFilled = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="HexagonCompleteFilledIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M12.005 0.990234L21.5353 6.49259V17.4973L12.005 22.9996L2.47461 17.4973V6.49259L12.005 0.990234Z" />
    </SvgIcon>
  );
};

export default HexagonCompleteFilled;
